<div class="documents-page">
  <!-- Документы из конфигурации -->
  <app-config-documents [pageName]="'documents'" [showPolicyLink]="true"></app-config-documents>
</div>
